<template>
  <div class="jl-account-info-wrap" v-cloak>
    <div class="jl-acc-info-box">
      <div class="item-main">
        <h2>个人信息</h2>
        <div class="main-info">
          <div class="main-info-form">
            <div class="form-ground">
              <label class="form-label">账号</label>
              <p class="text">
                {{formData.account}}
                <span class="span-1">{{formData.vipLevel === 0?'普通会员':'VIP会员'}}</span>
              </p>
            </div>
            <div class="form-ground">
              <label class="form-label">用户名</label>
              <p class="text alt-phone-edit" v-if="formData.userName && !isShowSetName">
                {{formData.userName}}
                <i class="jl-icon-bianji" @click="setName"></i>
              </p>
              <p
                class="text alt-phone active"
                v-if="!formData.userName && !isShowSetName"
                @click="setName"
              >去设置</p>
              <div class="jl-set-username-box" v-if="isShowSetName">
                <input class="input-username" v-model.trim="setuserName" type="text" />
                <div class="jl-username-operta">
                  <button class="jl-u-btn alt-red" @click="saveName">保存</button>
                  <button class="jl-u-btn" @click="cancelSetName">取消</button>
                </div>
              </div>
            </div>
            <div class="form-ground">
              <label class="form-label">绑定手机号</label>
              <p class="text alt-phone-edit" v-if="formData.phone">
                {{formData.phone}}
                <i class="jl-icon-bianji" @click="setPhone"></i>
              </p>
              <p class="text alt-phone active" v-else @click="setPhone">去绑定</p>
            </div>
            <div class="form-ground">
              <label class="form-label">消费金额</label>
              <p class="text active">￥ {{formData.consumeMoney?formData.consumeMoney:0}}</p>
            </div>
            <div class="form-ground">
              <label class="form-label">创建时间</label>
              <p class="text">{{formData.createDate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="item-right">
        <div class="item-r-box">
          <div class="top">
            <p class="text1">会员制度</p>
          </div>
          <div class="content">
            <ul class="list">
              <li>
                <p class="text1">普通会员</p>
                <p class="text2">用户注册成功后即可成为普通会员</p>
              </li>
              <li>
                <p class="text1">VIP会员</p>
                <p class="text2">VIP用户可看到网站展示的特殊锦鲤</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <v-setPhoneModal
      :phone="formData.phone"
      :showModal="isShowModal"
      :isModify="isModify"
      :userId="userInfo.userId"
      @cancel="cancelModal"
      @confim="confimModal"
    ></v-setPhoneModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUserInfo, setName } from "@/api/user";

import SetPhoneModal from "../../../components/SetPhoneModal";
export default {
  name: "informationIndex",
  components: {
    "v-setPhoneModal": SetPhoneModal
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      isShowModal: false, //是否显示绑定手机模态框
      isModify: false, // true=>是修改  false => 绑定
      formData: {},
      isShowSetName: false,
      setuserName: ""
    };
  },
  created() {
    getUserInfo(this);
  },
  methods: {
    //绑定手机号 || 修改绑定手机号
    setPhone(val) {
      this.isModify = this.formData.phone ? true : false;
      this.isShowModal = true;
      document.body.className = "overActive";
    },
    cancelModal() {
      this.isShowModal = false;
      document.body.className = "";
    },
    confimModal(val) {
      if (val) {
        this.userInfo.phone = val;
        this.$store.dispatch("setUserInfo", this.userInfo);
        this.isShowModal = false;
        document.body.className = "";
        getUserInfo(this);
      }
    },
    setName() {
      this.isShowSetName = true;
      this.setuserName = this.formData.userName;
    },
    cancelSetName() {
      this.isShowSetName = false;
    },
    saveName() {
      setName(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-acc-info-box {
  position: relative;
  padding-right: 300px;
  .item-main {
    position: relative;
    z-index: 10;
    background: #fff;
    min-height: 450px;
    box-shadow: 9px 0 14px rgba($color: #b8b8b8, $alpha: 0.1);
  }
  .item-main {
    padding: 25px 50px;
    h2 {
      font-size: 18px;
      color: #333;
      padding-bottom: 24px;
      border-bottom: 1px dashed #e0e0e0;
    }
  }
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
    height: 100%;
    background: #fff;
    padding-left: 18px;
    .item-r-box {
      padding: 0 15px;
    }
    .top {
      padding: 28px 0 24px 0;
      border-bottom: 1px dashed #e0e0e0;
      .text1 {
        position: relative;
        font-size: 16px;
        color: #e70819;
        padding-left: 19px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background: #e70819;
          transform: translateY(-50%);
        }
      }
    }
    .content {
      padding: 24px 15px 0 15px;
      .list {
        li {
          margin-bottom: 24px;
        }
        .text1 {
          font-size: 16px;
          color: #333;
          line-height: 28px;
        }
        .text2 {
          font-size: 14px;
          color: #999;
          line-height: 28px;
        }
      }
    }
  }
  .main-info-form {
    padding-top: 30px;
    .form-ground {
      position: relative;
      padding-left: 100px;
      margin-bottom: 38px;
      height: 30px;
      .form-label {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }
      .text {
        font-size: 14px;
        columns: #333;
        line-height: 30px;
        &.alt-phone {
          cursor: pointer;
        }
        &.active {
          color: #e70819;
        }
        .span-1 {
          display: inline-block;
          width: 92px;
          height: 32px;
          border-radius: 16px;
          font-size: 16px;
          color: #666;
          line-height: 32px;
          text-align: center;
          border: 1px solid #e0e0e0;
          margin-left: 30px;
        }
        &.alt-phone-edit {
          position: relative;
          i {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            font-size: 20px;
            color: #e70819;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.jl-set-username-box {
  position: relative;
  height: 100%;
  padding-right: 100px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
  .input-username {
    display: block;
    font-size: 14px;
    height: 100%;
    width: 100%;
    outline: none;
  }
  .jl-username-operta {
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .jl-u-btn {
    font-size: 12px;
    color: #666;
    padding: 0 5px;
    background: transparent;
    cursor: pointer;
    &.alt-red {
      color: #e70819;
    }
  }
}
</style>
